import React from 'react';
import { CircularProgress } from '@mui/material';
import { Typography } from '@vibTheme/components/_base/Typography';
import { CustomHelpTooltip } from '../CustomHelpTooltip';

/** Same shell as the sales cards, without the sparkline: these are ratios, not series. */
export const MetricCard = ({
  title,
  value,
  caption,
  help,
  indicator,
  isLoading,
}: {
  title: string;
  value: string;
  caption: string;
  help: string;
  indicator: React.ReactNode;
  isLoading: boolean;
}) => (
  <div className="flex flex-col shadow-default rounded-default">
    {isLoading ? (
      <div className="flex justify-center items-center h-[124px]">
        <CircularProgress />
      </div>
    ) : (
      <div className="p-md">
        <div className="flex items-center">
          <Typography className="text-gray-400">{title}</Typography>
          <div className="flex-1 flex items-center justify-between">
            <CustomHelpTooltip
              description={
                <Typography className="text-white text-xs p-sm">
                  {help}
                </Typography>
              }
            />
            {indicator}
          </div>
        </div>
        <Typography className="text-[#374151] text-3xl font-bold">
          {value}
        </Typography>
        <Typography className="text-xs text-lightBlack">{caption}</Typography>
      </div>
    )}
  </div>
);

/** 0 on an empty denominator: this table is built in the browser, so it needs its own guard. */
export const safeRate = (numerator: number, denominator: number) =>
  denominator ? numerator / denominator : 0;

/**
 * Reexportado de reportFormat, que é onde a implementação vive agora.
 *
 * Mantido aqui porque os componentes desta pasta e os testes importam deste módulo — mover a definição
 * sem o reexport seria uma renomeação disfarçada de refatoração. Mesmo padrão que RecurringRevenue/shared
 * já adotou.
 */
export { formatRate } from '../reportFormat';

export const formatMinutes = (minutes: number | null) => {
  if (minutes === null || !Number.isFinite(minutes)) return '—';
  if (minutes < 60) return `${Math.round(minutes)} min`;
  if (minutes < 1440) return `${(minutes / 60).toFixed(1)} h`;

  return `${(minutes / 1440).toFixed(1)} dias`;
};
